__turbopack_context__.v({
  "Primer": "result-card-module-scss-module__z6rDnG__Primer",
  "bestBest": "result-card-module-scss-module__z6rDnG__bestBest",
  "bestBet": "result-card-module-scss-module__z6rDnG__bestBet",
  "bestBetTitle": "result-card-module-scss-module__z6rDnG__bestBetTitle",
  "body": "result-card-module-scss-module__z6rDnG__body",
  "colorShift": "result-card-module-scss-module__z6rDnG__colorShift",
  "darkmode": "result-card-module-scss-module__z6rDnG__darkmode",
  "data": "result-card-module-scss-module__z6rDnG__data",
  "dataContainer": "result-card-module-scss-module__z6rDnG__dataContainer",
  "dataTitle": "result-card-module-scss-module__z6rDnG__dataTitle",
  "dataValue": "result-card-module-scss-module__z6rDnG__dataValue",
  "descriptor": "result-card-module-scss-module__z6rDnG__descriptor",
  "image": "result-card-module-scss-module__z6rDnG__image",
  "imageFallBack": "result-card-module-scss-module__z6rDnG__imageFallBack",
  "imageWrapper": "result-card-module-scss-module__z6rDnG__imageWrapper",
  "link": "result-card-module-scss-module__z6rDnG__link",
  "loading": "result-card-module-scss-module__z6rDnG__loading",
  "pastExhibition": "result-card-module-scss-module__z6rDnG__pastExhibition",
  "resultCard": "result-card-module-scss-module__z6rDnG__resultCard",
  "resultTeaser": "result-card-module-scss-module__z6rDnG__resultTeaser",
  "resultTitle": "result-card-module-scss-module__z6rDnG__resultTitle",
  "subTitle": "result-card-module-scss-module__z6rDnG__subTitle",
  "titles": "result-card-module-scss-module__z6rDnG__titles",
});
